import React from "react";
import PropTypes from "prop-types";
import { HeaderTooltip } from "./styles";

const HoverText = props => {
  return (
    <HeaderTooltip
      placement={props.mobile ? props.mobilePlacement : props.placement}
      title={props.title}
      overlayClassName={props.overlayClassName ? props.overlayClassName : ""}
    >
      {props.children}
    </HeaderTooltip>
  );
};

HoverText.propTypes = {
  children: PropTypes.any,
  mobile: PropTypes.bool,
  mobilePlacement: PropTypes.string,
  overlayClassName: PropTypes.string,
  placement: PropTypes.string,
  title: PropTypes.string
};

export default HoverText;
